<!-- 住所入力グループ: 郵便番号・都道府県・市区町村・番地・建物名の5項目セット -->
<template>
  <v-row class="form-row address-group" no-gutters>
    <v-col cols="12" md="2" class="form-label address-main-label">
      所在地
    </v-col>
    <v-col cols="12" md="10" class="address-fields-wrapper">
      <!-- 郵便番号 -->
      <div class="address-field-item">
        <div class="address-sub-label">
          郵便番号
          <span v-if="requireAddress" class="req">必須</span>
        </div>
        <div class="address-input-area">
          <v-text-field
            :model-value="modelValue.zip"
            @update:model-value="updateField('zip', $event)"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :rules="requireAddress ? [rules.requiredZip] : [rules.zip]"
            class="address-zip-field"
          />
          <v-btn
            variant="outlined"
            size="small"
            @click="$emit('search-address')"
            class="ml-2"
          >
            住所自動入力
          </v-btn>
          <span class="address-note ml-2">
            ※郵便番号から住所を自動入力します。半角数字/ハイフンなしで入力。
          </span>
        </div>
      </div>

      <!-- 都道府県 -->
      <div class="address-field-item">
        <div class="address-sub-label">
          都道府県
          <span v-if="requireAddress" class="req">必須</span>
        </div>
        <div class="address-input-area">
          <v-select
            :model-value="modelValue.prefecture"
            @update:model-value="updateField('prefecture', $event)"
            :items="prefectures"
            placeholder="選択してください"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :rules="requireAddress ? [rules.required] : []"
          />
        </div>
      </div>

      <!-- 市区町村 -->
      <div class="address-field-item">
        <div class="address-sub-label">
          市区町村
          <span v-if="requireAddress" class="req">必須</span>
        </div>
        <div class="address-input-area">
          <v-text-field
            :model-value="modelValue.city"
            @update:model-value="updateField('city', $event)"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :rules="requireAddress ? [rules.required] : []"
          />
        </div>
      </div>

      <!-- 番地等 -->
      <div class="address-field-item">
        <div class="address-sub-label">
          番地等
          <span v-if="requireAddress" class="req">必須</span>
        </div>
        <div class="address-input-area">
          <v-text-field
            :model-value="modelValue.address1"
            @update:model-value="updateField('address1', $event)"
            variant="outlined"
            density="compact"
            hide-details="auto"
            :rules="requireAddress ? [rules.required] : []"
          />
        </div>
      </div>

      <!-- 建物名等 -->
      <div class="address-field-item address-field-item-last">
        <div class="address-sub-label">建物名等</div>
        <div class="address-input-area">
          <v-text-field
            :model-value="modelValue.building"
            @update:model-value="updateField('building', $event)"
            variant="outlined"
            density="compact"
            hide-details="auto"
          />
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
interface AddressData {
  zip?: string | null;
  prefecture?: string | null;
  city?: string | null;
  address1?: string | null;
  building?: string | null;
}

const props = withDefaults(
  defineProps<{
    modelValue: AddressData;
    rules: Record<string, any>;
    prefectures: string[];
    requireAddress?: boolean;
  }>(),
  {
    requireAddress: true,
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: AddressData];
  "search-address": [];
}>();

function updateField(field: keyof AddressData, value: any) {
  emit("update:modelValue", { ...props.modelValue, [field]: value });
}
</script>
